import { React, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useWorkshops } from '../WorkshopContext';
import { getBaseUrl } from '../utils/apiConfig';
import CompareWorkshopsInfo from './CompareWorkshopsInfo';
import CompareWorkshopsGeneral from './CompareWorkshopsGeneral';
import CompareWorkshopsActivity1 from './CompareWorkshopsActivity1';
import CompareWorkshopsActivity2 from './CompareWorkshopsActivity2';
import CompareWorkshopsActivity3 from './CompareWorkshopsActivity3';
import './CompareWorkshops.css';

const initialSections = [
  {
    "title": "Compared workshops",
    "component": "CompareWorkshopsInfo",
    "buttons": [
      { "text": "Toggle visibility", "visible": true }
    ]
  },
  {
    "title": "General information",
    "component": "CompareWorkshopsGeneral",
    "buttons": [
      { "text": "Toggle visibility", "visible": true }
    ]
  },
  {
    "title": "Activity 1: Soil health challenges",
    "component": "CompareWorkshopsActivity1",
    "buttons": [
      { "text": "Toggle visibility", "visible": true }
    ]
  },
  {
    "title": "Activity 2: Soil functions",
    "component": "CompareWorkshopsActivity2",
    "buttons": [
      { "text": "Toggle visibility", "visible": true }
    ]
  },
  {
    "title": "Activity 3: Needs & Support",
    "component": "CompareWorkshopsActivity3",
    "buttons": [
      { "text": "Toggle visibility", "visible": true }
    ]
  }
];

const WorkshopPage = () => {
  
  const { state } = useWorkshops();
  const { idString } = useParams();
  const ids = idString.split(',').map(Number).filter(id => !isNaN(id));  
  const comparedWorkshops = state.workshops.filter(workshop => ids.includes(workshop.id))
  const [sections, setSections] = useState(initialSections);

  const [detailsById, setDetailsById] = useState({});

  const base = getBaseUrl();
  
  useEffect(() => {
    const ids = idString.split(',').map(Number).filter(id => !isNaN(id));

    const fetchWorkshopDetails = async (id) => {
      const response = await fetch(base + `/api/workshops/${id}`);
      const data = await response.json();
      return { id, data };
    };

    const fetchAllWorkshopDetails = async () => {
      const results = await Promise.all(ids.map(id => fetchWorkshopDetails(id)));
      const map = {};
      for (const { id, data } of results) {
        map[id] = data;
      }
      setDetailsById(map);
    };

    fetchAllWorkshopDetails();
  }, [idString, base]);

  const orderedDetails = useMemo(() => comparedWorkshops.map(w => detailsById[w.id]).filter(Boolean), [comparedWorkshops, detailsById]);

  if (orderedDetails.length !== comparedWorkshops.length) {
    return <div className='has-text-centered m-6 title is-3'>Loading...</div>;
  }
  
  const componentMap = {
    CompareWorkshopsInfo,
    CompareWorkshopsGeneral,
    CompareWorkshopsActivity1,
    CompareWorkshopsActivity2,
    CompareWorkshopsActivity3
  };  

  const toggleVisibility = (sectionIndex, buttonIndex) => {
    const newSections = [...sections];
    if (buttonIndex === 0) {
      const allVisible = newSections[sectionIndex].buttons.every(button => button.visible);
      newSections[sectionIndex].buttons.forEach(button => button.visible = !allVisible);
    } else {
      //newSections[sectionIndex].buttons[buttonIndex].visible = !newSections[sectionIndex].buttons[buttonIndex].visible;
    }
    setSections(newSections);
  };

  return (
    <div className="workshop-page">
      <section className="section">
        <div className="container">
          <div className='level mb-6'>
            <div className="level-item">
              Scroll to section:
            </div>
            {sections.filter((_, index) => index !== 0)
            .map((section, index) => (
              <button
                  key={index}
                  className='level-item button has-background-primary has-text-white is-rounded mx-3'
                  onClick={() => {                    
                    const element = document.getElementById(`section-${index + 1}`);
                    if (element) {
                      const navbarHeight = 120;
                      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                      const offsetPosition = elementPosition - navbarHeight;

                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    } else {
                      console.warn(`Element with ID section-${index + 1} not found`);
                    }
                  }}
                >
                  {section.title}
                </button>
            ))}
          </div>          
          {sections.map((section, sectionIndex) => {
            const Component = componentMap[section.component];
            return (
              <div id={`section-${sectionIndex}`} className="mb-6" key={sectionIndex}>
                <div className='columns has-text-centered compare-title  mb-3'>
                    <div className='column is-12 is-vcentered'>
                      <h1 className='title has-text-white'>                        
                          {section.title}
                          {section.buttons.length > 0 && (
                            <>
                              {section.buttons.map((button, buttonIndex) => (
                                <a
                                  key={buttonIndex}
                                  className="icon is-small is-pulled-right has-text-white pt-3 mt-1"
                                  onClick={() => toggleVisibility(sectionIndex, buttonIndex)}
                                >                                  
                                  <i className={button.visible ? 'fas fa-angle-up' : 'fas fa-angle-down'}></i>
                                </a>
                              ))}                          
                            </>
                          )}
                        
                      </h1>
                    </div>                    
                </div>
                {section.buttons.every(button => button.visible) && (
                  <Component
                    comparedWorkshops={comparedWorkshops}
                    comparedWorkshopDetails={orderedDetails}
                  />
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};
  
export default WorkshopPage;
